// Components
import CommonTopsection from "../../components/TopSection";
import ErrorBoundary from "../../components/ErrorBoundary";
// import MsaPopup from "../../components/MsaAgreement/MsaPopup";
// utils
import TableSection from "./TableSection";
import SmallDougnutTable from "../../components/TopSection/SmallDougnutTable";
import Heading from "../../components/Heading";
import DynamicComponentRenderer from "../../components/DynamicComponentRenderer";
import DrawStats from "./DrawStats";
import { useDispatch, useSelector } from "react-redux";
import { FooterComp } from "../Login/LoginComp";
import { TaxFormsAnnouncement } from "../../Utils/CustomComponent";
import "./dashboard.css";
import { Clipboard2Check, FileEarmarkText } from "react-bootstrap-icons";
import PopupWrapper from "../../components/PopupWrapper";
import CommonGrid from "../../components/CommonGrid";
import {
  gridColumns_RecentCompletedReports,
  gridColumns_scheduledReports_Download,
  gridColumns_scheduledReports_RunTime,
} from "../../Utils/TableColumnDefs";
import { useEffect, useState } from "react";
import axios from "axios";
import urls from "../../Utils/urls";
import { loadingTypes, oracleConfig } from "../../Utils/constant";
import { fetchPayoffDemands } from "../../store/reducers/dashboardSlice/api";
import { useAbortController } from "../../hooks/useAbortController";
import { toast } from "react-toastify";
import { commonToast } from "../../Utils";

const Dashboard = () => {
  const [showScheduledModal, setShowScheduledModal] = useState(false);
  const [showRecentReportsModal, setShowRecentReportsModal] = useState(false);
  const { kpis } = useSelector((state) => state.dashboard);
  const selectedRole = useSelector(
    (state) => state?.account?.selectedRole?.value,
  );
  const user = useSelector((state) => state.RS_Authentication.user);

  const dispatch = useDispatch();
  const { signal } = useAbortController();
  const { loanCount, status } = kpis;
  const userId = localStorage.getItem("apex_userid");

  useEffect(() => {
    if (selectedRole === "L")
      dispatch(
        fetchPayoffDemands({
          email: user?.details?.email,
          signal,
          selectedRole,
        }),
      );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRole]);

  const hasDrawsFeature = (() => {
    try {
      const userDetails = JSON.parse(localStorage.getItem("accessed_user"));
      const role = userDetails?.role?.find((r) => r.role_type === selectedRole);
      return !!role?.features?.some(
        (f) => f.feature_code === "DRAWS" && f.show_yn === "Y",
      );
    } catch {
      return false;
    }
  })();

  const componentConfig = [
    // {
    //   component: <TaxFormsAnnouncement />,
    //   // role: ["Both"],
    //   className: "col-sm-12 px-4",
    // },
    {
      component: (
        <Heading
          className="col-sm-12"
          text="My Dashboard"
          showMarquee={loanCount === 0 && status === "fulfilled" ? true : false}
        />
      ),
      // role: ["Both"],
      className: "col-sm-12 px-4",
    },
    {
      component: <CommonTopsection className="col-sm-12" />,
      // role: ["Both"],
      className: "col-sm-12 px-4 mb-5",
    },
    {
      component: (
        <ReportsWidget
          className="col-sm-12"
          setShowScheduledModal={setShowScheduledModal}
          showScheduledModal={showScheduledModal}
          showRecentReportsModal={showRecentReportsModal}
          setShowRecentReportsModal={setShowRecentReportsModal}
        />
      ),
      className: "col-sm-12 px-3 mb-5",
    },
    {
      component: <SmallDougnutTable className="col-sm-12" />,
      // role: ["Both"],
      className:
        "col-xl-12 col-lg-12 py-0 mb-5 px-4 portfolio-balance-upcoming-payments",
    },
    ...(hasDrawsFeature
      ? [
          {
            component: <DrawStats />,
            className: "col-sm-12 px-4 mb-5",
            role: ["L"],
          },
        ]
      : []),
    {
      component: <TableSection className="col-sm-12" />,
      // role: ["Both"],
      className: "col-sm-12",
    },
    {
      component: <FooterComp applyStyling={true} showTicketBtn={false} />,
      // role: ["Both"],
      className: "col-sm-12",
      role: ["L"],
    },
  ];
  return (
    <div
      className="text-start container-fluid my-0 px-0"
      style={{ overflowY: "scroll" }}
    >
      <section
        className=" rounded py-5"
        style={{ background: "#eeeeee", minHeight: "100vh" }}
      >
        <article className="container-fluid">
          <DynamicComponentRenderer componentConfig={componentConfig} />
        </article>
      </section>
    </div>
  );
};
export default Dashboard;

const ReportsWidget = ({
  setShowScheduledModal,
  showScheduledModal,
  showRecentReportsModal,
  setShowRecentReportsModal,
}) => {
  const [data, setData] = useState([]);
  const userId = localStorage.getItem("apex_userid");
  const [count, setCount] = useState("-");
  const [refresh, setRefresh] = useState(false);
  const [recentCompletedReports, setRecentCompletedReports] = useState([]);
  const [recentCompletedReportsCount, setRecentCompletedReportsCount] =
    useState("-");
  const selectedRole = useSelector(
    (state) => state?.account?.selectedRole?.value,
  );
  const [scheduledReportsStatus, setScheduledReportsStatus] = useState(
    loadingTypes.idle,
  );
  const [refreshForDownloadReports, setRefreshForDownloadReports] =
    useState(false);
  const [statusChecker, setStatusChecker] = useState({
    prevAction: null,
    currentstatus: null,
    scheduleId: null,
  });

  async function getScheduledRecords() {
    try {
      setScheduledReportsStatus(loadingTypes.loading);
      const res = await axios.get(
        urls.reportsWidget.scheduleReports(userId, selectedRole),
        oracleConfig,
      );

      setData(res?.data?.items);
      setCount(res?.data?.count);
      if (statusChecker.scheduleId) {
        const record = res?.data?.items?.filter(
          (el) => el.schedule_id === statusChecker.scheduleId,
        );
        if (record?.length) {
          setStatusChecker((prev) => ({
            ...prev,
            currentstatus: record[0]?.can_pause,
          }));

          if (record[0]?.can_pause === "Y") {
            toast.success(
              "Please check back after some time to view the latest report status.",
              {
                ...commonToast,
                position: "top-right"
              }
            );
          }
        }
      }
      setScheduledReportsStatus(loadingTypes.fulfilled);
    } catch (error) {
      console.error(error);
      setScheduledReportsStatus(loadingTypes.failed);
    }
  }

  async function getRecentCompletedReports() {
    try {
      const res = await axios.get(
        urls.reportsWidget.recentCompletedReports(userId, selectedRole),
        oracleConfig,
      );

      setRecentCompletedReports(res?.data?.items);
      setRecentCompletedReportsCount(res?.data?.count);
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    getScheduledRecords();
  }, [refresh, selectedRole]);

  useEffect(() => {
    getRecentCompletedReports();
  }, [selectedRole, refreshForDownloadReports]);

  return (
    <div className="row mt-3 gx-5">
      {/* Scheduled Reports */}
      <div className="col-lg-6 mb-3">
        <div className="dashboard-report-widget">
          <div className="dashboard-report-header">
            <div className="dashboard-report-title">
              <div className="dashboard-report-icon scheduled-icon">
                <FileEarmarkText />
              </div>

              <h5>Scheduled Reports</h5>
            </div>

            <button
              className="btn dashboard-view-btn"
              onClick={() => {
                setShowScheduledModal(true);
                setRefresh((prev) => !prev);
              }}
            >
              View All
            </button>
          </div>

          <div className="dashboard-report-body">
            {/* Empty State */}
            {count === "-" ? (
              <div className="dashboard-empty-state"> NO SCHEDULED REPORTS</div>
            ) : (
              <h2>{count}</h2>
            )}
          </div>
        </div>
      </div>

      {/* Recently Completed Reports */}
      <div className="col-lg-6 mb-3">
        <div className="dashboard-report-widget">
          <div className="dashboard-report-header">
            <div className="dashboard-report-title">
              <div className="dashboard-report-icon completed-icon">
                <Clipboard2Check />
              </div>

              <h5>Recently Completed Reports (Last 7 Days)</h5>
            </div>

            <button
              className="btn dashboard-view-btn"
              onClick={() => {
                setShowRecentReportsModal(true);
                setRefreshForDownloadReports((prev) => !prev);
              }}
            >
              View All
            </button>
          </div>

          <div className="dashboard-report-body">
            {/* Empty State */}
            {recentCompletedReportsCount === "-" ? (
              <div className="dashboard-empty-state"> NO RECENT REPORTS</div>
            ) : (
              <h2>{recentCompletedReportsCount}</h2>
            )}
          </div>
        </div>
      </div>
      <ScheduledReportsModal
        show={showScheduledModal}
        setShow={setShowScheduledModal}
        userId={userId}
        data={data}
        setRefresh={() => setRefresh((prev) => !prev)}
        status={scheduledReportsStatus}
        statusChecker={statusChecker}
        setStatusChecker={setStatusChecker}
      />
      <RecentlyCompletedReportsModal
        show={showRecentReportsModal}
        setShow={setShowRecentReportsModal}
        data={recentCompletedReports}
        setRefresh={() => setRefreshForDownloadReports((prev) => !prev)}
      />
    </div>
  );
};

const ScheduledReportsModal = ({
  show,
  setShow,
  data,
  userId,
  setRefresh,
  status,
  statusChecker,
  setStatusChecker,
}) => {
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [scheduleId, setScheduleId] = useState(null);

  return (
    <>
      <PopupWrapper
        Component={
          <ErrorBoundary>
            <CommonGrid
              className={""}
              title={"Scheduled Reports"}
              gridColumns={gridColumns_scheduledReports_RunTime(
                userId,
                setRefresh,
                setShowDownloadModal,
                setScheduleId,
                statusChecker,
                setStatusChecker,
              )}
              columnData={data}
              // status={status}
            />
          </ErrorBoundary>
        }
        title={
          <div className="px-5">
            Live Schedule & Run Monitor{" "}
            <div className="small text-muted">
              Track automatic reports & current background tasks
            </div>
          </div>
        }
        toShow={show}
        closeEventHandler={() => {
          setShow(false);
        }}
        headerClassName="px-5 py-3"
      />

      <DownloadModal
        show={showDownloadModal}
        setShow={setShowDownloadModal}
        scheduleId={scheduleId}
      />
    </>
  );
};

const RecentlyCompletedReportsModal = ({ show, setShow, data, setRefresh }) => {
  return (
    <PopupWrapper
      Component={
        <ErrorBoundary>
          <CommonGrid
            className={""}
            title={"Reports completed in the last 7 days"}
            gridColumns={gridColumns_RecentCompletedReports}
            columnData={data}
            status={"fulfilled"}
          />
        </ErrorBoundary>
      }
      title={"Recently Completed Reports"}
      toShow={show}
      closeEventHandler={() => {
        setShow(false);
      }}
      headerClassName="px-5 py-5"
      titleClassName="px-5 py-3"
    />
  );
};

export const DownloadModal = ({ show, setShow, scheduleId }) => {
  const [data, setData] = useState([]);
  const [status, setStatus] = useState(loadingTypes.idle);

  useEffect(() => {
    async function getDownloads() {
      try {
        setStatus(loadingTypes.loading);
        const res = await axios.get(
          urls.reportsWidget.downloadReport(scheduleId),
          oracleConfig,
        );

        const resData = res?.data?.items;
        setData(resData);
        setStatus(loadingTypes.fulfilled);
      } catch (error) {
        console.error(error);
        setStatus(loadingTypes.failed);
      }
    }

    if (scheduleId) {
      getDownloads();
    }
  }, [scheduleId]);

  return (
    <PopupWrapper
      Component={
        <ErrorBoundary>
          <CommonGrid
            className={""}
            title={"Last 7 Report Runs"}
            gridColumns={gridColumns_scheduledReports_Download}
            columnData={data}
            status={status}
            tHeight={"40vh"}
            minHeight={"100%"}
            header={false}
            footer={false}
            // viewAllModal={false}
          />
        </ErrorBoundary>
      }
      title={"Last 7 Report Runs"}
      toShow={show}
      closeEventHandler={() => {
        setShow(false);
      }}
      headerClassName="px-5 py-3"
      titleClassName="px-5 py-3"
      dialogClassName="kmw-70"
    />
  );
};
